var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MenuList',{staticClass:"pa-2",attrs:{"routers":_vm.$router.options.routes,"filter":_vm.filterRoute,"dense":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }